<template>
  <div>
    <div v-if="sent && !sending" class="alert alert-success" role="alert">
      Verification code successfully sent.
    </div>

    <p>We sent an email with a verification code to {{ user.email }}</p>
    <p class="mt-4" style="cursor: pointer" @click="onResend">
      <u>Resend Verification code</u>
    </p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      sent: false,
      sending: false,
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  methods: {
    async onResend() {
      if (this.sending) return

      this.sending = true

      await this.$api
        .post('/auth/verification/resend')
        .then(() => (this.sent = true))
        .finally(() => (this.sending = false))
    },
  },
}
</script>
